import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';

const editModeService = {
  checkIsEditMode(deliveryId: number): Promise<CommonResponse<any>> {
    const url = '/check-is-editmode?delivery_id=' + deliveryId;
    return axiosClient.get(url);
  },
};

export default editModeService;
